import { useRef, useState } from "react"
import { footerLinkClass } from "../lightTheme"
import LegalDocumentModal from "./LegalDocumentModal"
import { legalDocuments } from "./legalModalContent"

const footerLinks = [
  { id: "privacy" },
  { id: "terms" },
  { id: "contact" },
]

export default function LightFooter() {
  const [openId, setOpenId] = useState(null)
  const returnFocusRef = useRef(null)

  return (
    <div className="w-full max-w-[1200px]">
      <footer className="ml-[calc(50vw-50%-1.5rem)] flex w-full flex-wrap items-center justify-end bg-[#FAFAFA] pb-10 pt-24">
        {footerLinks.map((link, index) => (
          <span key={link.id} className="inline-flex items-center">
            {index > 0 ? (
              <span aria-hidden="true" className="px-2 text-[10px] leading-none text-[#4D4D4D]">
                ·
              </span>
            ) : null}
            <button
              type="button"
              className={`${footerLinkClass} border-0 bg-transparent font-[inherit]`}
              onClick={(event) => {
                returnFocusRef.current = event.currentTarget
                setOpenId(link.id)
              }}
            >
              {legalDocuments[link.id].title}
            </button>
          </span>
        ))}
      </footer>
      <LegalDocumentModal
        document={openId ? legalDocuments[openId] : null}
        onClose={() => setOpenId(null)}
        returnFocusRef={returnFocusRef}
      />
    </div>
  )
}
